import React, { useState, useEffect } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiFillDashboard,
  AiOutlineUnorderedList,
  AiOutlineShoppingCart,
  AiFillMediumCircle,
  AiFillSketchCircle,
  AiOutlineFund,
  AiFillMessage,
  AiFillWechat,
  AiFillPhone,
  AiFillRead,
  AiFillPlusCircle,
  AiFillNotification,
  AiOutlineFontColors,
  AiFillGold,
  AiOutlineUser,
  AiOutlineBgColors,
  AiOutlineSetting,
} from "react-icons/ai";
import { RiCouponLine } from "react-icons/ri";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { ImBlog } from "react-icons/im";
import { IoIosNotifications } from "react-icons/io";
import { FaClipboardList, FaBloggerB } from "react-icons/fa";
import { SiBrandfolder } from "react-icons/si";
import { BiCategoryAlt } from "react-icons/bi";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../features/auth/authSlice";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { config } from "../utils/axiosconfig";
import { resolveMediaUrl } from "../utils/mediaUrl";

const { Header, Sider, Content } = Layout;
const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Fetch profile data from Redux state
  const { user, profile } = useSelector((state) => state.auth);

  // useEffect(() => {
  //   console.log("User in MainLayout:", user);
  //   if (user?._id) {
  //     console.log("Dispatching getProfile with ID:", user._id);
  //     dispatch(getProfile(user._id)); // Pass the admin's ID to the thunk
  //   }
  // }, [dispatch, user]);

  useEffect(() => {
    console.log("User in MainLayout:", user);
    if (user.data && user.data._id) {
      console.log("Dispatching getProfile with ID:", user.data._id);
      dispatch(getProfile(user.data._id)); // Pass the admin's ID to the thunk
    } else {
      console.error("User ID is missing. Cannot fetch profile.");
    }
  }, [dispatch, user]);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleLogout = async () => {
    try {
      // Retrieve the token from localStorage
      const token = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).data.token
        : null;

        console.log(token);
  
      if (!token) {
        console.error("Authorization token is missing.");
        return;
      }
  
      // Configure headers with the token
      const headers = {
        Authorization: `Bearer ${token}`,
      };
  
      // Call the logout API with the token
      await axios.post(`${base_url}admin/logout`, {}, { headers });
  
      // Clear user data from localStorage
      localStorage.removeItem("user");
  
      // Redirect to the login page
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <Layout  /* onContextMenu={(e) => e.preventDefault()} */>
      <Sider trigger={null} collapsible collapsed={collapsed} theme="light" style={{ background: 'linear-gradient(to bottom, var(--color-be3144), var(--color-872341))' }}>
        <div className="h-[68px] bg-common-clr">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo">BM</span>
            <span className="lg-logo">B M Jewels</span>
          </h2>
        </div>
        <Menu
          theme="light"
          className="custom-menu"
          style={{ background: 'linear-gradient(var(--color-872341))' }}
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
              navigate("/");
            } else {
              navigate(key);
            }
          }}
          items={[
            {
              key: "",
              icon: <AiFillDashboard className="fs-4" />,
              label: "Dashboard",
            },
            {
              key: "customers",
              icon: <AiOutlineUser className="fs-4" />,
              label: "Customers",
            },
            {
              key: "Catalog",
              icon: <AiFillRead className="fs-4" />,
              label: "Catalog",
              children: [
                {
                  key: "Product",
                  icon: <AiFillSketchCircle className="fs-4" />,
                  label: "Product",
                  children: [
                    {
                      key: "product",
                      icon: <AiFillPlusCircle className="fs-4" />,
                      label: "Add Product",
                    },
                    {
                      key: "list-product",
                      icon: <AiOutlineUnorderedList className="fs-4" />,
                      label: "Product List",
                    },
                  ]
                },
                {
                  key: "Metal",
                  icon: <AiFillMediumCircle className="fs-4" />,
                  label: "Metal",
                  children: [
                    {
                      key: "metal",
                      icon: <AiFillPlusCircle className="fs-4" />,
                      label: "Metal",
                    },
                    {
                      key: "list-metal",
                      icon: <AiOutlineUnorderedList className="fs-4" />,
                      label: "Metal List ",
                    },
                  ]
                },
                {
                  key: "Purity",
                  icon: <AiFillGold className="fs-4" />,
                  label: "Purity",
                  children: [
                    {
                      key: "purity",
                      icon: <AiFillPlusCircle className="fs-4" />,
                      label: "Purity",
                    },
                    {
                      key: "list-Purity",
                      icon: <AiOutlineUnorderedList className="fs-4" />,
                      label: "Purity List ",
                    },
                  ]
                },
                {
                  key: "Category",
                  icon: <BiCategoryAlt className="fs-4" />,
                  label: "Category",
                  children: [
                    {
                      key: "category",
                      icon: <AiFillPlusCircle className="fs-4" />,
                      label: "Category",
                    },
                    {
                      key: "list-category",
                      icon: <AiOutlineUnorderedList className="fs-4" />,
                      label: "Category List",
                    },
                  ]
                },
                // {
                //   key: "Color",
                //   icon: <AiOutlineFontColors className="fs-4" />,
                //   label: "Color",
                //   children: [
                //     {
                //       key: "color",
                //       icon: <AiFillPlusCircle className="fs-4" />,
                //       label: "Color",
                //     },
                //     {
                //       key: "list-color",
                //       icon: <AiOutlineUnorderedList className="fs-4" />,
                //       label: "Color List",
                //     },
                //   ]
                // },
                {
                  key: "Promotional",
                  icon: <AiFillNotification className="fs-4" />,
                  label: "Promotional",
                  children: [
                    {
                      key: "Promotional",
                      icon: <AiFillPlusCircle className="fs-4" />,
                      label: "Promotional",
                    },
                    {
                      key: "list-Promotional",
                      icon: <AiOutlineUnorderedList className="fs-4" />,
                      label: "Promotional List",
                    },
                  ]
                },
                {
                  key: "Banner",
                  icon: <AiOutlineFund className="fs-4" />,
                  label: "Banner",
                  children: [
                    {
                      key: "banner",
                      icon: <AiFillPlusCircle className="fs-4" />,
                      label: "Banner",
                    },
                    {
                      key: "list-banner",
                      icon: <AiOutlineUnorderedList className="fs-4" />,
                      label: "Banner List",
                    },
                  ]
                },
                {
                  key: "ImageFeed",
                  icon: <AiOutlineBgColors className="fs-4" />,
                  label: "Image Feed",
                  children: [
                    {
                      key: "image-feed",
                      icon: <AiFillPlusCircle className="fs-4" />,
                      label: "Add Image Feed",
                    },
                    {
                      key: "list-image-feed",
                      icon: <AiOutlineUnorderedList className="fs-4" />,
                      label: "Image Feed List",
                    },
                  ]
                },
              ],
            },
            // {
            //   key: "orders",
            //   icon: <FaClipboardList className="fs-4" />,
            //   label: "Orders",
            // },
            // {
            //   key: "marketing",
            //   icon: <RiCouponLine className="fs-4" />,
            //   label: "Marketing",
            //   children: [
            //     {
            //       key: "coupon",
            //       icon: <ImBlog className="fs-4" />,
            //       label: "Add Coupon",
            //     },
            //     {
            //       key: "coupon-list",
            //       icon: <RiCouponLine className="fs-4" />,
            //       label: "Coupon List",
            //     },
            //   ],
            // },
            // {
            //   key: "blogs",
            //   icon: <FaBloggerB className="fs-4" />,
            //   label: "Blogs",
            //   children: [
            //     {
            //       key: "blog",
            //       icon: <ImBlog className="fs-4" />,
            //       label: "Add Blog",
            //     },
            //     {
            //       key: "blog-list",
            //       icon: <FaBloggerB className="fs-4" />,
            //       label: "Blog List",
            //     },
            //     {
            //       key: "blog-category",
            //       icon: <ImBlog className="fs-4" />,
            //       label: "Add Blog Category",
            //     },
            //     {
            //       key: "blog-category-list",
            //       icon: <FaBloggerB className="fs-4" />,
            //       label: "Blog Category List",
            //     },
            //   ],
            // },
            {
              key: "reviews",
              icon: <AiFillWechat className="fs-4" />,
              label: "Reviews",
            },
            {
              key: "enquiries",
              icon: <AiFillPhone className="fs-4" />,
              label: "Enquiries",
            },
            {
              key: "custom-designs",
              icon: <AiFillSketchCircle className="fs-4" />,
              label: "Custom Designs",
            },
            {
              key: "product-enquiries",
              icon: <AiOutlineShoppingCart className="fs-4" />,
              label: "Product Enquiries",
            },
            {
              key: "gold-scheme-menu",
              icon: <AiFillGold className="fs-4" />,
              label: "11+1 / Gold Scheme",
              children: [
                {
                  key: "gold-scheme",
                  icon: <AiFillPlusCircle className="fs-4" />,
                  label: "Add Scheme Customer",
                },
                {
                  key: "list-gold-scheme",
                  icon: <AiOutlineUnorderedList className="fs-4" />,
                  label: "Scheme List",
                },
              ],
            },
            {
              key: "settings",
              icon: <AiOutlineSetting className="fs-4" />,
              label: "Settings",
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">
            {/* <div className="position-relative">
              <IoIosNotifications className="fs-4" />
              <span className="badge bg-warning rounded-circle p-1 position-absolute">
                3
              </span>
            </div> */}

            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
                <img
                  width={32}
                  height={32}
                  src={profile?.image ? resolveMediaUrl(profile.image) : "default-profile.png"} // Use profile image
                  // src="https://stroyka-admin.html.themeforest.scompiler.ru/variants/ltr/images/customers/customer-4-64x64.jpg"
                  alt=""
                />
              </div>
              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <h5 className="mb-0">{profile?.name || "User Name"}</h5>
                <p className="mb-0">{profile?.email || "user@example.com"}</p>
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/admin/profile"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    onClick={handleLogout}
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="dark"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
